module.exports = __webpack_public_path__ + "static/media/slide4.ca97f176.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/DesignersPen/slide4.png
// module id = 1100
// module chunks = 0